import { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { FloralLineArt } from "./Ornaments";

const TARGET = new Date("2026-11-26T18:00:00+05:30").getTime();

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "mins", label: "Minutes" },
  { key: "secs", label: "Seconds" },
];

function getTimeLeft() {
  const d = Math.max(0, TARGET - Date.now());
  return {
    days: String(Math.floor(d / 86400000)),
    hours: String(Math.floor(d / 3600000) % 24).padStart(2, "0"),
    mins: String(Math.floor(d / 60000) % 60).padStart(2, "0"),
    secs: String(Math.floor(d / 1000) % 60).padStart(2, "0"),
  };
}

export default function Countdown() {
  const [t, setT] = useState(getTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setT(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      id="countdown"
      className="countdown"
      data-testid="countdown-section"
    >
      <div className="count-fline fline-tl" aria-hidden="true">
        <FloralLineArt width={210} />
      </div>
      <div className="count-fline fline-br" aria-hidden="true">
        <FloralLineArt width={210} />
      </div>
      <Reveal>
        <div className="kicker" style={{ color: "var(--champagne-deep)" }}>
          26 November 2026
        </div>
        <h2 className="serif">Until we say &ldquo;I do&rdquo;</h2>
        <div className="timer" aria-live="polite" data-testid="countdown-timer">
          {UNITS.map((u) => (
            <div key={u.key}>
              <span className="num serif" data-testid={`countdown-${u.key}`}>
                {t[u.key]}
              </span>
              <span className="label">{u.label}</span>
            </div>
          ))}
        </div>
        <div className="divider" />
        <div className="count-note">A little closer to forever.</div>
      </Reveal>
    </section>
  );
}
